<template>
  <ValidationProvider
    :vid="vid"
    :name="$attrs.name"
    :rules="rules"
    v-slot="{ valid, errors }"
  >
    <b-form-group v-bind="$attrs">
      <b-input-group>
        <b-form-input
          v-model="innerValue"
          v-bind="$attrs"
          autocomplete="off"
          :state="errors[0] ? false : valid ? true : null"
        ></b-form-input>
        <b-input-group-append>
          <b-button variant="success" class="w-100">
            <b-icon icon="eye-slash-fill"></b-icon>
          </b-button>
        </b-input-group-append>
      </b-input-group>
      <b-form-invalid-feedback style="display:inherit; ">{{
        errors[0]
      }}</b-form-invalid-feedback>
    </b-form-group>
  </ValidationProvider>
</template>

<script>
export default {
  props: {
    vid: {
      type: String,
    },
    rules: {
      type: [Object, String],
      default: "",
    },
    value: {
      type: null,
    },
  },
  data: () => ({
    innerValue: "",
  }),
  watch: {
    innerValue(newVal) {
      this.$emit("input", newVal);
    },
    value(newVal) {
      this.innerValue = newVal;
    },
  },
  created() {
    if (this.value) {
      this.innerValue = this.value;
    }
  },
};
</script>
